import {
  DocumentGroupName,
  GraphQLDocumentObjectType,
} from 'types/documents-types';

export const MULTIPLE_DOCUMENTS_TYPES: {
  [key: string]: DocumentGroupName[];
} = {
  [DocumentGroupName.INVESTMENT_DOCUMENTS]: [
    DocumentGroupName.SUBSCRIPTION_AGREEMENTS,
    DocumentGroupName.TRANSFER_AGENT,
  ],
  [DocumentGroupName.LANDA]: [],
  [DocumentGroupName.TAXES]: [],
  [DocumentGroupName.SUBSCRIPTION_AGREEMENTS]: [],
  [DocumentGroupName.TRANSFER_AGENT]: [],
};

export const getLegalDocuments = (documents?: GraphQLDocumentObjectType[]) => {
  const legalDocuments: { [key: string]: GraphQLDocumentObjectType } = {};
  documents?.forEach((document) => {
    if (document.groupName === DocumentGroupName.LANDA)
      legalDocuments[document.documentLabel] = document;
  });

  return legalDocuments;
};

export const getSubscriptionDocuments = (
  documentGroupName: DocumentGroupName,
  documents?: GraphQLDocumentObjectType[]
) => {
  const subscriptionDocuments: {
    [key: string]: GraphQLDocumentObjectType[];
  } = {};
  const orderedDocuments: GraphQLDocumentObjectType[][] = [];
  documents?.forEach((document) => {
    if (
      document.groupName === documentGroupName ||
      MULTIPLE_DOCUMENTS_TYPES[documentGroupName]?.includes(document.groupName)
    ) {
      if (subscriptionDocuments?.[document.documentUri]) {
        subscriptionDocuments[document.documentUri].push(document);
      } else {
        subscriptionDocuments[document.documentUri] = [document];
      }
    }
  });

  Object.keys(subscriptionDocuments).forEach((item) =>
    orderedDocuments.push(subscriptionDocuments[item])
  );
  orderedDocuments.sort((a, b) => a.length - b.length);

  return orderedDocuments;
};
